import axios from 'axios';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { DataNotFound } from '../../../components/DataNotFound';
import EventSelectionCart from '../../../components/cards/EventSelectionCart';
import Userbanner from '../../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync, postAsync } from '../../../components/helper/axiosHelper';
import {
  GET_VOLT_EVENT_SELECTION_DATA,
  POST_EVENT_REGISTER_FORM_DATA,
  SET_DATA,
  SET_VOlLUNTEER_EVENT_DATA,
  initialState,
  reducer,
} from '../../../features/FormReducers/GlobalFormFeatures';
import { useFileHandler } from '../../../hooks/useFileHandler';
import { DownloadSection } from './DownloadSection';
import { PageHitCountApi } from '../../../shared/Helper';
const VolunteerEventSelection = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { file, handleFileInputChange, getFileBase64 } = useFileHandler();
  const isActive = useSelector((state) => state.toggle.isActive);
  const [eventsNotFound, setEventsNotFound] = useState({
    message: '',
    statusCode: 0,
  });
  const date = useRef(null);
  // Dispatch the donorID to Redux

  const [formData, setFormData] = useState([]);
  const [epUserID, setEpUserID] = useState(null);

  const token = localStorage.getItem('token');
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset,
  } = useForm();
  const { t } = useTranslation();

  const onSubmit = async (formData) => {
    const {
      eventArabic,
      eventEnglis,
      descriptionArabic,
      descriptionEnglish,
      noOfVolunteer,
      days,
      dateStart,
      startTime,
      endDate,
      endTime,
    } = formData;

    try {
      const base64URL = await getFileBase64();
      const data = {
        activeID: 1,
        userID: epUserID,
        volunteerEventID: 0,
        eventNameAr: eventArabic,
        eventNameEn: eventEnglis,
        descAr: descriptionArabic,
        descEn: descriptionEnglish,
        file: file,
        base64URL: base64URL,
        volunteerNumber: parseInt(noOfVolunteer),
        days: parseInt(days),
        startDate: dateStart,
        startTime: startTime,
        endDate: endDate,
        endTime: endTime,
      };

      if (data) {
        axios
          .post(POST_EVENT_REGISTER_FORM_DATA, data, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            toast.success('Form submitted successfully');
            dispatch({ type: SET_DATA, payload: response.data });
            reset();
          })
          .catch((error) => {
            console.error('Form submission failed:', error);
            toast.error('Form not submitted');
          });
      }
    } catch (error) {
      console.error('File processing error:', error);
      toast.error('Error processing file');
    }
  };

  // GET VolunteerEventSelewction

  const getVolEventSelection = async () => {
    try {
      axios
        .post(GET_VOLT_EVENT_SELECTION_DATA, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
          epUserID: epUserID,
        })
        .then((response) => {
          if (response.data.statusCode === 204) {
            setEventsNotFound({
              message: response.data.message,
              statusCode: response.data.statusCode,
            });
          }
          dispatch({
            type: SET_VOlLUNTEER_EVENT_DATA,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    if (epUserID !== null) {
      getVolEventSelection();
      PageHitCountApi(location.pathname, epUserID);
    }
  }, [epUserID]);

  const fetchData = (id) => {
    getAsync('Volunteer/GetEPVolunteerEventById', { id: id })
      .then((response) => {
        setFormData(response.data[0]);
      })
      .catch((error) => {
        console.log(`error${error}`);
      });
  };

  const createbody = {
    volunteerEventRegID: 0,
    volunteerEventID: formData?.volunteerEventID,
    epUserID: epUserID,
  };

  const Participate = async () => {
    try {
      if (formData?.volunteerEventID !== undefined) {
        await postAsync('Volunteer/CreateEPVolunteerEventReg', createbody).then((response) => {
          if (response?.statusCode === 200) {
            toast.success(t('Registration successful. Waiting for approval.'));
            reset({
              eventArabic: '',
              eventEnglis: '',
              descriptionArabic: '',
              descriptionEnglish: '',
              noOfVolunteer: '',
              days: '',
              dateStart: null,
              startTime: '',
              endDate: null,
              endTime: '',
              dateStart: '',
              endDate: '',
            });
            setFormData([]);
            getVolEventSelection();
            window.location.href = '/VolunteerUpEventSeleList';
          } else {
            toast.error(`${t('Something went wrong, Please try again!')}`);
          }
        });
      } else {
        toast.warning(`${t('Please Select Event.')}`);
      }
    } catch (error) {
      console.log('error', error);
    }
  };
  const parseDate = (dateStr) => {
    if (!dateStr) return null;

    const [day, month, year] = dateStr.split('/');
    return new Date(year, month - 1, day);
  };

  return (
    <div className="pt-12 ">
      <Userbanner />
      <div className="container-fluid pb-5">
        <div className="pt-3  justify-center text-center">
          <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">
            {t('Volunteer Event Selection')}
          </h1>
        </div>
        {eventsNotFound.statusCode === 204 ? (
          // <p className='text-4xl min-h-56 text-center mt-4'>
          //   { t(eventsNotFound.message) }
          // </p>
          <DataNotFound />
        ) : (
          <>
            <div className="flex flex-wrap justify-center gap-3 ">
              {state.eventSelecton.map((data, index) => {
                return (
                  <EventSelectionCart
                    index={index}
                    title={isActive ? data.eventNameAr : data?.eventNameEn}
                    img={data?.doc}
                    id={data?.volunteerEventID}
                    startDate={data?.startDate}
                    endDate={data?.endDate}
                    onClick={(id) => fetchData(id)}
                  />
                );
              })}
            </div>

            {/* form */}
            <section
              id="form-section"
              style={{
                paddingTop: '30px',
              }}
            >
              <div className="my-2 lg:px-5 cotainer-fluid text-black">
                <Form className="" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row px-2">
                    <div className="col-sm-6 my-2">
                      <Form.Group controlId="eventArabic">
                        <label className="text-black">{t('Name of Event - Arabic')}</label>
                        <Form.Control
                          className=" w-full border border-gray-300 text-customgreen bg-white text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                          type="text"
                          disabled
                          value={formData?.eventNameAr}
                          {...register('eventArabic', { required: true })}
                        />
                        {errors.skills && (
                          <Form.Control.Feedback type="invalid">
                            {t('Please enter Name of Event Arabic')}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-sm-6 my-2">
                      <Form.Group controlId="eventEnglis">
                        <label className="text-black">{t('Name of Event - English')}</label>
                        <Form.Control
                          className=" w-full border border-gray-300 text-customgreen bg-white text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                          type="text"
                          disabled
                          value={formData?.eventNameEn}
                          {...register('eventEnglis', { required: true })}
                        />
                        {errors.skills && (
                          <Form.Control.Feedback type="invalid">
                            {'Please enter Name of Event English'}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-sm-6 my-2">
                      <Form.Group controlId="descriptionArabic">
                        <label className="text-black">{t('Description-Arabic')}</label>
                        {/* Use Form.Control as="textarea" for textarea input */}
                        <Form.Control
                          className=" w-full border border-gray-300 text-customgreen bg-white text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                          as="textarea"
                          disabled
                          rows={3} // Adjust the number of columns as needed
                          value={formData?.descAr}
                          {...register('descriptionArabic', { required: true })}
                        />
                        {errors.skills && (
                          <Form.Control.Feedback type="invalid">
                            {'Please enter Description Arabic'}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-sm-6 my-2">
                      <Form.Group controlId="descriptionEnglish">
                        <label className="text-black">{t('Description-English')}</label>
                        {/* Use Form.Control as="textarea" for textarea input */}
                        <Form.Control
                          className=" w-full border border-gray-300 text-customgreen bg-white text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                          as="textarea"
                          disabled
                          value={formData?.descEn}
                          rows={3} // Adjust the number of columns as needed
                          {...register('descriptionEnglish', { required: true })}
                        />
                        {errors.skills && (
                          <Form.Control.Feedback type="invalid">
                            {t('Please enter Description English')}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div>
                    {/* <Table striped bordered hover controlId='volunteerAPTable'>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>First Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Mark</td>
                  <td>Otto</td>
                </tr>
              </tbody>
            </Table> */}
                    <DownloadSection formData={formData}></DownloadSection>
                  </div>

                  <div className=" row px-2">
                    <div className="col-sm-6 ">
                      <Form.Group controlId="dateStart">
                        <div className="form-group flex flex-col gap-2 ">
                          <label>{t('Start Date')}</label>
                          <DatePicker
                            selected={parseDate(formData?.startDate)}
                            className=" w-full border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500   p-2.5"
                            placeholderText="DD/MM/YYYY"
                            dateFormat="dd/MM/yyyy"
                            disabled
                            // onChange={(date) => field.onChange(date)}

                            // { ...register('dateStart', { required: false }) }
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-sm-6 ">
                      <Form.Group controlId="startTime">
                        <div className="form-group flex flex-col gap-2 ">
                          <label className="text-black">{t('Start Time')}</label>
                          <Form.Control
                            className=" w-full border border-gray-300 text-customgreen bg-white text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                            type="time"
                            disabled
                            value={formData?.startTime}
                            {...register('startTime', { required: false })}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-sm-6 my-2 ">
                      <Form.Group controlId="endDate" className="">
                        <div className="form-group flex flex-col gap-2 ">
                          <label>{t('End Date')}</label>
                          <DatePicker
                            ref={date}
                            selected={parseDate(formData?.endDate)}
                            className=" w-full  border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500   p-2.5"
                            placeholderText="DD/MM/YYYY"
                            dateFormat="dd/MM/yyyy"
                            disabled
                            // onChange={(date) => field.onChange(date)}

                            // { ...register('endDate', { required: false }) }
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-sm-6 my-2 ">
                      <Form.Group controlId="endTime" className="">
                        <div className="form-group flex flex-col gap-2 ">
                          <label className="text-black">{t('End Time')}</label>
                          <Form.Control
                            className=" w-full border border-gray-300 text-customgreen bg-white text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                            type="time"
                            disabled
                            value={formData?.endTime}
                            {...register('endTime', { required: false })}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-sm-6 my-2 ">
                      <Form.Group controlId="noOfVolunteer" className="">
                        <div className="form-group flex flex-col gap-2 ">
                          <label className="text-black">{t('Number of Volunteer')}</label>
                          <Form.Control
                            className=" w-full border border-gray-300 text-customgreen bg-white text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                            type="number"
                            disabled
                            value={formData?.volunteerNumber}
                            {...register('noOfVolunteer', { required: true })}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-sm-6 my-2">
                      <Form.Group controlId="days" className="">
                        <div className="form-group flex flex-col gap-2 ">
                          <label className="text-black">{t('Days')}</label>
                          <Form.Control
                            className=" w-full border border-gray-300 text-customgreen bg-white text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
                            type="number"
                            disabled
                            value={formData?.days}
                            max={50}
                            min={1}
                            {...register('days', { required: true })}
                          />
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                </Form>
              </div>
            </section>

            <div className="flex justify-center pb-6">
              <button
                //disabled={formData?.volunteerEventID ? false : true}
                onClick={Participate}
                className="select-none text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2.5 me-2 text-center"
                type="button"
              >
                {t('Participate')}
              </button>
            </div>
          </>
        )}

        {/* cards */}
      </div>
    </div>
  );
};

export default VolunteerEventSelection;
